export const SIGNATURE_FIELD_NAME = "name"

/**
 * Slug of the DSB visitor agreement document, as returned by the enrollment
 * agreement slugs API. Only TDC batches at DSB are eligible for it.
 */
export const DSB_AGREEMENT_SLUG = "dsb-visitor-agreement-form"

/**
 * The agreement itself, rendered inline page by page. Named after the slug
 * because the backend stores the two together.
 */
export const DSB_AGREEMENT_PDF_URL = `https://assets.suraasa.com/enrollment-agreements/${DSB_AGREEMENT_SLUG}.pdf`

export enum OnboardingStepId {
  learnersAgreement = "learnerAgreement",
  termsOfUse = "termsOfUse",
  privacyPolicy = "privacyPolicy",
  tdc_dsbAgreement = "tdc_dsbAgreement",
}

export const currentStepTitle = {
  [OnboardingStepId.learnersAgreement]: "Enrollment agreement",
  [OnboardingStepId.termsOfUse]: "Terms of use",
  [OnboardingStepId.privacyPolicy]: "Privacy policy",
  [OnboardingStepId.tdc_dsbAgreement]:
    "DSB Child Protection - Visitor Agreement Form",
}
